import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';

interface IShareParams {
    dealId: number;
    proFormaId: number;
    payload: {
        recipientEmail: string;
        personalMessage?: string;
    };
}

const shareProForma = async ({ dealId, proFormaId, payload }: IShareParams) => (
    axiosInstance.post(API_ENDPOINTS.PRO_FORMA(dealId, proFormaId) + '/share', payload).then(r => r.data)
);

export const useShareProForma = () => useMutation({ mutationFn: shareProForma });

export default useShareProForma;
